import { HotelsConfig } from '../types';

const MAX_DAYS_INTERVAL = 28;

type Params = {
  hotelsConfig?: HotelsConfig;
  countryCode?: string;
};

export const getMaxDaysIntervalByConfig = ({ hotelsConfig, countryCode }: Params) => {
  const defaultNights = hotelsConfig?.stayLimits?.nights
    ? hotelsConfig?.stayLimits?.nights + 1
    : MAX_DAYS_INTERVAL;

  if (!countryCode) {
    return defaultNights;
  }

  const nightsByCountry = hotelsConfig?.stayLimits?.countries?.find(
    (country) => country.code === countryCode
  )?.nights;

  if (nightsByCountry) {
    return nightsByCountry + 1;
  }

  return defaultNights;
};
